import { useState } from "react";
import { useLocation } from "react-router-dom";
import { forgotPassword } from "../../api";
import { Button } from "../../components/common/Button";

export const ForgotPasswordPage: React.FC = () => {
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || "");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleRequestReset = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setMessage("");

    try {
      await forgotPassword(email);
      setMessage("Se l'email è registrata, riceverai un link per reimpostare la password.");
    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <div className="flex items-center justify-center bg-gray-100">
      <form
        onSubmit={handleRequestReset}
        className="bg-white shadow-md rounded px-8 py-6 w-full max-w-sm"
      >
        <h2 className="text-2xl font-bold mb-6 text-center">Reset Password</h2>

        {error && <div className="text-red-600 text-sm mb-4">{error}</div>}
        {message && <div className="text-green-600 text-sm mb-4">{message}</div>}

        <label className="block text-gray-700 text-sm mb-2">Email</label>
        <input
          type="email"
          className="border border-gray-300 rounded w-full px-3 py-2 mb-4"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <Button type="submit" variant="primary">
          Invia link reset
        </Button>
      </form>
    </div>
  );
}
